import { defineComponent as _defineComponent } from 'vue'
import ActionModal from 'JS/components/modals/ActionModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PackoutMessageModal',
  props: {
    message: null
  },
  setup(__props: any) {

const props = __props as {
	message: string;
}




return { __sfc: true,props, ActionModal }
}

})